import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import Clientes from "../pages/clients/page";
import ClienteDetail from "../pages/clients/detail/page";
import Catalogo from "../pages/catalog/page";
import Suscripciones from "../pages/subscriptions/page";
import Cobranza from "../pages/billing/page";
import RequireAuth from "@/components/feature/RequireAuth";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <RequireAuth />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "clientes",
        element: <Clientes />,
      },
      {
        path: "clientes/:id",
        element: <ClienteDetail />,
      },
      {
        path: "catalogo",
        element: <Catalogo />,
      },
      {
        path: "suscripciones",
        element: <Suscripciones />,
      },
      {
        path: "cobranza",
        element: <Cobranza />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;